<template>
  <v-slide-y-transition mode="out-in">
    <v-container class=" pa-0 pb-4 fluid">      
      <v-layout column>
        <v-flex sm12>
          <view-eks v-if="showFormEks"></view-eks>
          <view-leg v-if="showFormLeg"></view-leg>
          <view-dpd v-if="showFormDpd"></view-dpd>              
        </v-flex>
      </v-layout>  
    </v-container>
  </v-slide-y-transition>
</template>
<script>
import ViewEks from './view-eks';
import ViewLeg from './view-leg';
import ViewDpd from './view-dpd';

export default {
  components: {
    ViewEks,
    ViewLeg,
    ViewDpd
  },
  data () {
    return {
      //chat: null,
      //selectedTab: null,
    };
  },
  computed: {
    showFormEks() {
      return this.$route.query.mode == 1;
    },
    showFormLeg() {
      return this.$route.query.mode == 2;
    },
    showFormDpd() {
      return this.$route.query.mode == 3;
    },            
  },
};
</script>

